import { Component, Input } from "@angular/core";
import { FamilyMemberModel } from "../brother-attribution-models/family-model";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "brother-attribution-brief-results",
  template: ` <div class="brother-attribution-brief-results">
    <div *ngIf="_child.parents" class="column">
      {{ (translations$ | async).parents }}: {{ _child.parents }}
    </div>
    <div *ngIf="_child.israeliId" class="column">{{ _child.israeliId }}</div>
    <div *ngIf="_child.layer" class="column">{{ _child.layer }}</div>
    <div *ngIf="_child.nest" class="column">{{ _child.nest }}</div>
  </div>`,
  styleUrls: ["brother-attribution-brief-results-view.component.scss"],
})
export class BrotherAttributionBriefResultsViewComponent {
  public translations$: Observable<ITranslations>;
  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
  public _child: FamilyMemberModel;
  @Input() set child(child: FamilyMemberModel) {
    this._child = child;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/brother-attribution-brief-results-view/brother-attribution-brief-results-view.component.ts